import { api } from "@/api";
import { League } from "@/types/ApiResponses/League";
import { QueryProps } from "@/types/Api";

interface Props {
  name?: string;
  lang?: string;
  popular?: boolean;
  sportId?: number;
  countryId?: number;
}

export const getFavoriteLeagues = async (
  props: QueryProps<Props>
): Promise<League[]> => {
  const res = await api.client.get(`/leagues-new/favorite`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
